export default "__VITE_ASSET__d607845d__$_?component__"